import { IPostData } from '@/interfaces/api/post';
import { linkifyText } from '@/utils/dom';
import DOMPurify from 'dompurify';
import React from 'react';
import IcTokenBurn from './icTokenBurn';
import s from './styles.module.scss';

interface IProps {
  data: IPostData;
}

const BurnTokenPost: React.FC<IProps> = ({ data }): React.ReactElement => {
  const onClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className={s.lixiPost}>
      <div className={s.content}>
        <span
          onClick={onClick}
          dangerouslySetInnerHTML={{
            __html: linkifyText(DOMPurify.sanitize(data?.content)),
          }}
        />
      </div>
      <IcTokenBurn />
      {/* <img
        className={s.rainLixiIcon}
        src={`${CDN_URL_ICONS}/token_airdrops.svg`}
        alt="ic-airdrop"
      /> */}
    </div>
  );
};

export default React.memo(BurnTokenPost);
